(function () {
  function init(root) {
    if (!root || root.dataset.swiperInitialized === 'true') return;
    var sliderEl = root.querySelector('.company__main__slider');
    var scrollbarEl = root.querySelector('.swiper-scrollbar-company');
    var nextEl = root.querySelector('.companybtnnext');
    var prevEl = root.querySelector('.companybtnprev');
    if (!sliderEl || !scrollbarEl || !nextEl || !prevEl || !window.Swiper) return;

    var instance = new Swiper(sliderEl, {
      scrollbar: { el: scrollbarEl, hide: false, draggable: true },
      navigation: { nextEl: nextEl, prevEl: prevEl },
      keyboard: { enabled: true, onlyInViewport: true },
      simulateTouch: true,
      grabCursor: true,
      slidesPerView: 1.6,
      spaceBetween: 16,
      breakpoints: {
        540: { slidesPerView: 3, spaceBetween: 20 },
        900: { slidesPerView: 4, spaceBetween: 24 }
      }
    });

    root._swiperInstance = instance;
    root.dataset.swiperInitialized = 'true';
  }

  function initWhenReady(root) {
    if (window.Swiper) {
      init(root);
    } else {
      var tries = 0;
      var t = setInterval(function () {
        if (window.Swiper) {
          clearInterval(t);
          init(root);
        }
        if (++tries > 80) clearInterval(t);
      }, 50);
    }
  }

  function initAll() {
    document.querySelectorAll('.shop-by-concern').forEach(initWhenReady);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.querySelector('.shop-by-concern[data-section-id="' + e.detail.sectionId + '"]');
    if (root) {
      if (root.dataset.swiperInitialized === 'true' && root._swiperInstance && root._swiperInstance.destroy) {
        root._swiperInstance.destroy(true, true);
        root.dataset.swiperInitialized = 'false';
      }
      initWhenReady(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = document.querySelector('.shop-by-concern[data-section-id="' + e.detail.sectionId + '"]');
    if (root && root._swiperInstance && root._swiperInstance.destroy) {
      root._swiperInstance.destroy(true, true);
      root.dataset.swiperInitialized = 'false';
      root._swiperInstance = null;
    }
  });
})();
